import { Link, useNavigate } from "react-router-dom";
import { useRef, useEffect } from "react";

export default function DelayLink({
                                      to,
                                      replace = false,
                                      delay = 0,
                                      onDelayStart = () => {},
                                      onDelayEnd = () => {},
                                      clickAction,
                                      ...props
                                  }) {
    const navigate = useNavigate();
    const timeoutRef = useRef(null);

    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    const handleClick = (e) => {
        if (clickAction) clickAction();

        onDelayStart(e, to);
        if (e.defaultPrevented) return;

        e.preventDefault();

        timeoutRef.current = setTimeout(() => {
            navigate(to, { replace });
            onDelayEnd(e, to);
        }, delay);
    };

    return <Link to={to} {...props} onClick={handleClick} />;
}
